function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { Input, Button, Divider, Form, Alert, InputNumber, Modal, Descriptions } from "antd";
import Common from '../includes/Common';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var AddOfficeProvision = function AddOfficeProvision(_ref) {
  var item = _ref.item,
    handler = _ref.handler;
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    formError = _useState2[0],
    setFormError = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormLoading = _useState4[0],
    setIsFormLoading = _useState4[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    setFormError('');
    setIsFormLoading(true);
    confirm({
      title: "Confirmez-vous ?",
      content: "Opération entrée de " + values.quantity + " " + item.label,
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "officeprovision", {
          id: item.id.toString(),
          quantity: values.quantity,
          note: values.note
        }).then(function (response) {
          if (response.data.status == 200) {
            handler();
          } else {
            setFormError(response.data.message);
          }
        })["catch"](function (error) {
          setFormError('Une erreur est survenue');
        })["finally"](function () {
          setIsFormLoading(false);
        });
      }
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      comment: ''
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Descriptions, {
      title: /*#__PURE__*/_jsx("b", {
        children: item.label
      }),
      column: 1,
      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
        label: /*#__PURE__*/_jsx("b", {
          children: "CATEGORIE"
        }),
        children: item.item_category.label
      }), /*#__PURE__*/_jsx(Descriptions.Item, {
        label: /*#__PURE__*/_jsx("b", {
          children: "QTE DISPONIBLE"
        }),
        children: item.available_quantity
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("h5", {
      children: /*#__PURE__*/_jsx("b", {
        children: "NOUVELLE ENTREE"
      })
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      onFinish: onFinish,
      layout: "vertical",
      size: "large",
      children: [formError.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: formError,
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Quantit\xE9",
        name: "quantity",
        rules: [{
          required: true,
          message: 'Champ obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Commentaire",
        name: "note",
        children: /*#__PURE__*/_jsx(TextArea, {
          autoSize: true
        })
      }), ContextHolder, /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          loading: isFormLoading,
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "Valider"
          })
        })
      })]
    })]
  });
};
export default AddOfficeProvision;